var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 713,
    height: 641,
    viewBox: "0 0 713 641",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4530_2396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.705 536.693C340.597 536.693 321.855 519.319 321.855 497.912C321.855 476.49 340.599 459.133 363.705 459.133C386.796 459.133 405.538 476.488 405.538 497.912C405.538 519.319 386.796 536.693 363.705 536.693Z",
    fill: "#E54C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.285 638.639H86.5357C56.0925 638.639 28.8356 622.901 13.6043 596.542C-1.60769 570.184 -1.60769 538.707 13.6043 512.35L283.479 44.9017C298.71 18.5446 325.969 2.80469 356.403 2.80469C386.854 2.80469 414.125 18.5446 429.318 44.9089L699.202 512.35C714.421 538.69 714.431 570.17 699.209 596.542C683.987 622.903 656.721 638.639 626.285 638.639ZM356.403 39.2512C339.142 39.2512 323.683 48.1769 315.038 63.125L45.1705 530.556C36.5352 545.514 36.5352 563.363 45.1705 578.321C53.7987 593.276 69.265 602.211 86.5357 602.211H626.285C643.539 602.211 659.017 593.276 667.66 578.321C676.298 563.363 676.281 545.514 667.645 530.556L397.768 63.125C389.142 48.1673 373.683 39.2512 356.403 39.2512Z",
    fill: "#E54C42",
    stroke: "#E54C42",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.62 223.481C398.68 224.527 398.68 225.606 398.62 226.629L386.997 448.796C379.744 446.203 371.931 444.636 363.704 444.636C355.467 444.636 347.65 446.203 340.382 448.796L328.776 226.629C327.841 208.744 342.698 193.548 362.01 192.687C381.299 191.828 397.703 205.596 398.62 223.481Z",
    fill: "#E54C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4530_2396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 713,
    height: 641,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.93c105afe5268eaf080572f7429d5648.svg";
export { ForwardRef as ReactComponent };